import IndividualDevelopmentPlanDetailView from './component';
import _routes from './routes';
import _BottomButtons from './BottomButtons';

export const routes = _routes;
export const BottomButtons = _BottomButtons;

export default IndividualDevelopmentPlanDetailView;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanDetailView/index.js